export default "__VITE_ASSET__D7OTs2Bl__"